import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, filter, delay } from 'rxjs/operators';
import { zefDialogOpen } from '@zerops/zef/dialog';
import { authActions } from '@zerops/zef/auth';
import { sudoReauthActions } from '../sudo-reauth';
import { FEATURE_NAME } from './recovery-code-issued-dialog.constant';

@Injectable()
export class RecoveryCodeIssuedDialogEffect {
  #actions$ = inject(Actions);

  /**
   * Opens the recovery code dialog when TOTP login returns a new recovery code.
   * This happens when the user authenticates with a recovery code instead of TOTP.
   */
  onLoginTOTPSuccess$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(authActions.verifyTOTPCodeSuccess),
      filter(({ data }) => !!data?.newRecoveryToken),
      map(({ data }) =>
        zefDialogOpen({
          key: FEATURE_NAME,
          meta: { code: data.newRecoveryToken }
        })
      )
    )
  );

  /**
   * Opens the recovery code dialog when sudo TOTP authentication returns a new recovery code.
   * This happens when the user uses a recovery code for sudo re-authentication.
   */
  onSudoTOTPSuccess$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(sudoReauthActions.submitTOTPSuccess),
      filter(({ data }) => !!data?.newRecoveryToken),
      // Delay to allow the dialog to be on 'top'
      delay(1000),
      map(({ data }) =>
        zefDialogOpen({
          key: FEATURE_NAME,
          meta: { code: data.newRecoveryToken }
        })
      )
    )
  );
}
